<template>
  <v-container class="overview-page">

    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>line_style</v-icon>
          {{ $t('book/admin:process-step.overview.title') }}
        </h2>

        <DataTable
            :enabledSearch="true"
            :addBtn="true"
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/process/steps/edit`"
            :addBtnText="$t('buttons:add-specific', { specific: $t('common:process-step')})"
            :headers="headers"
            :data="table.data"
            icon="create"
            @clickedButton1="editProcessStep"
            checkbox-on-property="userAddsAnswer"
            checkbox-on-property2="documentationRequired"
            sortBy="name"
            @cacheCommit="$store.commit('book/admin/storeProcessStepOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.processStepOverviewSearch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTable from "@/modules/core/components/DataTable/DataTable";
import ProcessStepService from "@/modules/book/services/process/impl/process-step-service";
import DataUtils from "@/modules/core/services/data-utils";
import ProcessStep from '@/modules/book/data/processStep'
import Utils from "@/modules/core/services/utils";

export default {
  name: "ProcessStepOverview",
  components: {
    DataTable,
  },
  data() {
    return {
      table: {
        data: []
      }
    }
  },
  methods: {
    editProcessStep(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/admin/process/steps/edit/${item.id}`);
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t("common:process-step"), value: 'name'},
        {text: this.$t("common:description"), value: 'description'},
        {text: this.$t("book/admin:process-step.overview.datatable.free-text"), value: 'checkbox', sortable: false},
        {text: this.$t("book/admin:process-step.overview.datatable.doc-required"), value: 'checkbox2', sortable: false},
        {text: this.$t("common:settings"), value: 'controls', sortable: false},
      ]
    }
  },
  created() {
    ProcessStepService.readAllFromAPI(
      (res) => {
        this.table.data = DataUtils.parseDataToObjectArray(res.data, ProcessStep);
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:process-step_plural')}))
        this.$logger.error(error);
      }
    )
  }
}
</script>
<style lang="scss">

.wrap-word {
  word-break: break-all;
}

</style>
